// Google Ads conversion tracking helpers.
// Replace the placeholder labels below with the real conversion labels from
// Google Ads → Tools → Conversions → (your action) → "Tag setup" → "Use Google tag".
// The label looks like "abcDEFghiJKL123" and combines with the account ID as
// "AW-18345613315/abcDEFghiJKL123".

const GOOGLE_ADS_ID = "AW-18345613315";

const CONVERSION_LABELS = {
  // Existing "Contact" action. Keep this on completed forms only until the
  // dedicated labels below are created in Google Ads.
  booking: "uST2COOLndkcEIOw76tE",
  airportBooking: "REPLACE_WITH_AIRPORT_BOOKING_LABEL",
  phoneCall: "REPLACE_WITH_PHONE_CALL_LABEL",
  whatsapp: "REPLACE_WITH_WHATSAPP_LABEL",
} as const;

const DEFAULT_VALUES: Record<ConversionName, number> = {
  booking: 75,
  airportBooking: 150,
  phoneCall: 75,
  whatsapp: 40,
};

const EVENT_NAMES: Record<ConversionName, string> = {
  booking: "booking_form_submit",
  airportBooking: "airport_booking_submit",
  phoneCall: "phone_call_click",
  whatsapp: "whatsapp_click",
};

export type ConversionName = keyof typeof CONVERSION_LABELS;

export type ConversionOptions = {
  value?: number;
  distanceKm?: number;
  airport?: boolean;
};

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackConversion(name: ConversionName, options: ConversionOptions = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  const airport =
    options.airport ??
    (name === "airportBooking" ||
      /melbourne-airport|tullamarine/.test(window.location.pathname));
  const longTrip = (options.distanceKm ?? 0) >= 35;
  const value = options.value ?? (airport || longTrip ? 150 : DEFAULT_VALUES[name]);

  // These distinct events remain measurable before dedicated Ads labels are
  // added, and can be imported as separate conversion actions later.
  window.gtag("event", EVENT_NAMES[name], {
    value,
    currency: "AUD",
    lead_type: name,
    trip_type: airport ? "airport" : longTrip ? "long_trip" : "standard",
    high_value: airport || longTrip,
    distance_km: options.distanceKm,
    page_path: window.location.pathname,
  });

  const label = CONVERSION_LABELS[name];
  if (!label || label.startsWith("REPLACE_WITH_")) return;
  window.gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_ID}/${label}`,
    value,
    currency: "AUD",
  });
}